export const isSuperManager = (accesses, companyId) => {
  const companyIndex = accesses.findIndex(access => access.company.id === Number(companyId));
  return accesses[companyIndex]?.units?.includes("*");
}

